import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.5 6.5h3v3h-3zM6.5 6.5h3v3h-3zM6 15.5h12M18 16.5h-1M17 17.5h-1M8 17.5H7M7 16.5H6M16 17.5H8" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }